const types = {
  SUBSCRIBE_LOG_START: 'SUBSCRIBE_LOG_START',
  SUBSCRIBE_LOG_SUCCESS: 'SUBSCRIBE_LOG_SUCCESS',
  SUBSCRIBE_LOG_FAILURE: 'SUBSCRIBE_LOG_FAILURE',

  SUBSCRIBE_START: 'SUBSCRIBE_START',
  SUBSCRIBE_SUCCESS: 'SUBSCRIBE_SUCCESS',
  SUBSCRIBE_FAILURE: 'SUBSCRIBE_FAILURE',

  GET_BALANCE: 'SUBSCRIPTION/GET_BALANCE',
  GET_BALANCE_SUCCESS: 'SUBSCRIPTION/GET_BALANCE_SUCCESS',
  GET_BALANCE_FAILURE: 'SUBSCRIPTION/GET_BALANCE_FAILURE',

  INITIATE_RAZORPAY_PAYMENT: 'SUBSCRIPTION/INITIATE_RAZORPAY_PAYMENT',
  INITIATE_RAZORPAY_PAYMENT_SUCCESS: 'SUBSCRIPTION/INITIATE_RAZORPAY_PAYMENT_SUCCESS',
  INITIATE_RAZORPAY_PAYMENT_FAILURE: 'SUBSCRIPTION/INITIATE_RAZORPAY_PAYMENT_FAILURE',

  COMPLETE_RAZORPAY_PAYMENT: 'SUBSCRIPTION/COMPLETE_RAZORPAY_PAYMENT',
  COMPLETE_RAZORPAY_PAYMENT_SUCCESS: 'SUBSCRIPTION/COMPLETE_RAZORPAY_PAYMENT_SUCCESS',
  COMPLETE_RAZORPAY_PAYMENT_FAILURE: 'SUBSCRIPTION/COMPLETE_RAZORPAY_PAYMENT_FAILURE',

  SUBSCRIBE_PAY: 'SUBSCRIBE_PAY',
  SUBSCRIBE_PAY_SUCCESS: 'SUBSCRIBE_PAY_SUCCESS',
  SUBSCRIBE_PAY_FAILURE: 'SUBSCRIBE_PAY_FAILURE',
};

export default types;
